'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _title = require('./title');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_title).default;
  }
});

var _semanticTitles = require('./semantic-titles');

Object.defineProperty(exports, 'TitleOne', {
  enumerable: true,
  get: function get() {
    return _semanticTitles.TitleOne;
  }
});
Object.defineProperty(exports, 'TitleThree', {
  enumerable: true,
  get: function get() {
    return _semanticTitles.TitleThree;
  }
});
Object.defineProperty(exports, 'TitleSix', {
  enumerable: true,
  get: function get() {
    return _semanticTitles.TitleSix;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }